import { PRODUCT } from '@ahmdigital/constants';

import { SalesIllustrationsProps } from './types';
import CHEAPEST_PRODUCT from '../../../../../../../models/product/cheapest-product';
import dentistImage from './images/dentist.png';
import injuredImage from './images/injured.png';
import styles from './styles.module.sass';
import teeth from './images/teeth.png';
import teethLeftMobile from './images/teeth-left-mobile.svg';
import teethRight from './images/teeth-right.svg';

const EXTRAS_OPTIONS = ['Routine dental', 'Other included services'];
const HOSPITAL_OPTIONS = ['Unlimited Medically Necessary Ambulance^', 'No excess for dependants'];

const EXTRAS_CONTAINER_CLASS = styles.extrasVariant;
const HOSPITAL_CONTAINER_CLASS = styles.hospitalVariant;

const HOSPITAL_IMAGE_CONFIG = {
  left: {
    alt: 'Injured member illustration',
    classKey: 'leftImage',
    src: injuredImage.src,
  },
  right: {
    alt: 'Dentist illustration',
    classKey: 'rightImage',
    src: dentistImage.src,
  },
} as const;

const EXTRAS_IMAGE_CONFIG = {
  left: {
    alt: 'Teeth illustration',
    classKey: 'leftImage',
    mobileSrc: teethLeftMobile.src,
    src: teeth.src,
  },
  right: {
    alt: 'Teeth illustration',
    classKey: 'rightImage',
    src: teethRight.src,
  },
} as const;

export const EXTRA_OPTIONS_PROPS: SalesIllustrationsProps = {
  className: EXTRAS_CONTAINER_CLASS,
  leftImage: EXTRAS_IMAGE_CONFIG.left,
  options: EXTRAS_OPTIONS,
  productId: PRODUCT.BLACK_50_SAVER_EXTRAS,
  rightImage: EXTRAS_IMAGE_CONFIG.right,
  title: 'Extras cover starts from',
} as const;

export const HOSPITAL_OPTIONS_PROPS: SalesIllustrationsProps = {
  className: HOSPITAL_CONTAINER_CLASS,
  leftImage: HOSPITAL_IMAGE_CONFIG.left,
  options: HOSPITAL_OPTIONS,
  productId: CHEAPEST_PRODUCT.HOSPITAL,
  rightImage: HOSPITAL_IMAGE_CONFIG.right,
  title: 'Hospital cover starts from',
} as const;
